import type {
  CmsSectionDTO,
  CmsSectionUpdateInput,
} from "@/modules/cms/domain/contracts";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { CmsSectionDTO };

// --- Sections (admin จัดการ; หน้าเว็บเป็น static) ---

export const cmsSectionsApi = {
  async list(pageKey: string): Promise<CmsSectionDTO[]> {
    const url = new URL(`${config.apiUrl}/cms/sections`);
    url.searchParams.set("pageKey", pageKey);
    return fetcher.get<CmsSectionDTO[]>(url.toString());
  },

  async get(id: string): Promise<CmsSectionDTO> {
    return fetcher.get<CmsSectionDTO>(`${config.apiUrl}/cms/sections/${id}`);
  },

  async create(body: {
    pageKey: string;
    sectionKey: string;
    content?: Record<string, unknown> | unknown[];
    sortOrder?: number;
  }): Promise<CmsSectionDTO> {
    return fetcher.post<CmsSectionDTO>(`${config.apiUrl}/cms/sections`, body);
  },

  async update(
    id: string,
    body: CmsSectionUpdateInput,
  ): Promise<CmsSectionDTO> {
    return fetcher.put<CmsSectionDTO>(
      `${config.apiUrl}/cms/sections/${id}`,
      body,
    );
  },

  async delete(id: string): Promise<{ id: string }> {
    return fetcher.delete<{ id: string }>(
      `${config.apiUrl}/cms/sections/${id}`,
    );
  },

  async reorder(
    pageKey: string,
    order: Array<{ id: string; sortOrder: number }>,
  ): Promise<CmsSectionDTO[]> {
    return fetcher.post<CmsSectionDTO[]>(
      `${config.apiUrl}/cms/sections/reorder`,
      { pageKey, order },
    );
  },
};
